// src/services/UserStateService.ts

export type UserState = {
  id: string | null;
  name: string | null;
  email: string | null;
}

class UserStateService {
  private static instance: UserStateService;
  private userState: UserState = {
    id: null,
    name: null,
    email: null
  };
  private listeners: Set<(state: UserState) => void> = new Set();

  private constructor() {}

  static getInstance(): UserStateService {
    if (!UserStateService.instance) {
      UserStateService.instance = new UserStateService();
    }
    return UserStateService.instance;
  }

  getState(): UserState {
    return { ...this.userState };
  }

  setUserInfo(id: string, name: string, email: string) {
    this.userState = { id, name, email };
    this.notifyListeners();
  }

  clearUserInfo() {
    this.userState = { id: null, name: null, email: null };
    this.notifyListeners();
  }

  subscribe(listener: (state: UserState) => void) {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notifyListeners() {
    this.listeners.forEach(listener => listener(this.getState()));
  }
}

export const userStateService = UserStateService.getInstance();